import { WEB_LINK_REGEXP } from 'shared/constants/regExp'

import { ConvertedFile } from './fileUpload'

type SeparatedFiles = {
  newFiles: ConvertedFile[]
  oldFiles: ConvertedFile[]
}

export const getSeparatedFiles = (files: ConvertedFile[]): SeparatedFiles => {
  const newFiles: ConvertedFile[] = []
  const oldFiles: ConvertedFile[] = []

  for (const photo of files) {
    if (WEB_LINK_REGEXP.test(photo.content)) {
      oldFiles.push(photo)
    } else {
      newFiles.push(photo)
    }
  }

  return { newFiles, oldFiles }
}
